import React from 'react'
import { InhouseGameDetails } from 'config/types/game'
import DiceEventProvider from './DiceEventProvider'
import DiceActionProvider from './DiceActionProvider'

const DiceContext: React.FC<React.PropsWithChildren & { game: InhouseGameDetails }> = ({ children, game }) => {
  return (
    <DiceEventProvider>{game && <DiceActionProvider game={game}>{children}</DiceActionProvider>}</DiceEventProvider>
  )
}

export default DiceContext
